import { request } from 'src/api/request';

export const getPayerType = async ({ queryParams }) => {
  return await request({
    url: `v1/entities/payer-types/${queryParams}`,
    method: 'GET',
  });
};
